import React from 'react';
import '../index.scss';

interface FilterFooterButtonsProps {
  onConfirm: (optionsValue: any[]) => void;
  onCancel: () => void;
  optionsValue: any[];
  searchValue: string;
  formatMessage: (message: { id: string; }) => string;
  setIsOpen: (open: boolean) => void;
  value: string[];
  setValue:(value: string[]) => void;
  isRevertToLastSelection: boolean;
}

const FilterFooterButtons: React.FC<FilterFooterButtonsProps> = ({
  onConfirm,
  onCancel,
  optionsValue,
  searchValue,
  formatMessage,
  setIsOpen,
  value,
  setValue,
  isRevertToLastSelection
}) => {
  const handleClick = (event: { stopPropagation: () => void; }) =>{
    // 阻止事件冒泡，点击div时下拉自动隐藏
    event.stopPropagation();
    return false;
  };

  return(
    <div className="dbd-footer-btn" onClick={handleClick}>
      <button
        className="tea-btn dbi-revenue-btn-left"
        onClick={() => {
          if (optionsValue.length === 0 && searchValue) {
            return;
          }
          onConfirm(optionsValue);
          setIsOpen(false);
        }}
      >
        {formatMessage({ id: 'confirm' })}
      </button>
      <button
        className="tea-btn tea-btn--weak dbi-revenue-btn-right"
        onClick={() => {
          setIsOpen(false);
          onCancel();
          if(isRevertToLastSelection){
            setValue(value);
          }
        }}
      >
        {formatMessage({ id: 'cancel' })}
      </button>
    </div>
  );
};

export default FilterFooterButtons;
